import {
  FormJson,
  Question,
} from "../types/feedback.types";
import { FORM_CONSTANTS } from "../constants/form.constants";

/**
 * Get question text for a specific language
 */
export const getQuestionText = (
  question: Question,
  languageId: number,
  baseLanguageId: number = FORM_CONSTANTS.DEFAULT_LANGUAGE_ID
): string => {
  const textArr = question?.text || [];

  // Try exact language match
  const found = textArr.find(
    (t) => Number(t.languageId) === Number(languageId)
  );
  if (found?.text) return found.text;

  // Fallback to base language
  const base = textArr.find(
    (t) => Number(t.languageId) === Number(baseLanguageId)
  );
  if (base?.text) return base.text;

  // Final fallback
  return (
    textArr[0]?.text || question?.questionText || question?.title || "Question"
  );
};

/**
 * Get visible questions from form
 */
export const getVisibleQuestions = (formJson: FormJson | null): Question[] => {
  if (!formJson) return [];
  return (formJson.questions || []).filter((q) =>
    q.visible === undefined ? true : Boolean(q.visible)
  );
};